import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import { FecalScoring, FecalScoringModuleState } from '../../model/fecal-scoring.model';
import * as actions from '../actions/fecal-scoring.actions';

export const adapter: EntityAdapter<FecalScoring> = createEntityAdapter<FecalScoring>();

export const initialState = {
  fecalScorings: null,
  locationId: null,
  isLoaded: false,
} as FecalScoringModuleState;

const FecalScoringReducer = createReducer(
  initialState,
  on(actions.clearFecalScoringState, (state) => ({
    ...state,
    isLoaded: false,
    fecalScorings: null as FecalScoring[],
    locationId: null as number,
    selectedFecalScoring: undefined as FecalScoring,
  })),
  on(actions.clearSelectedFecalScoring, (state) => ({
    ...state,
    selectedFecalScoring: undefined as FecalScoring,
  })),
  on(actions.getFecalScoringsSuccess, (state, { fecalScorings }) => ({
    ...state,
    fecalScorings,
    isLoaded: true,
  })),
  on(actions.setSelectedFecalScoringSuccess, (state, { fecalScoring }) => ({
    ...state,
    selectedFecalScoring: fecalScoring,
  })),
  on(actions.deleteFecalScoringSuccess, (state, { fecalScoringId }) => ({
    ...state,
    selectedFecalScoring: undefined as FecalScoring,
    fecalScorings: [...state.fecalScorings.filter((c) => c.id !== fecalScoringId)],
  })),
);

export function reducer(state: FecalScoringModuleState | undefined, action: Action) {
  return FecalScoringReducer(state, action);
}
